module.exports = __webpack_public_path__ + "img/wisdom_banner.ef82b034.png";